/**
 * useCommunityVideos -- read-only list of a community's native (Cloudflare)
 * videos for the detail page carousel. Polls every 4s while any row is still
 * pending/processing so a just-uploaded video flips to playable, then stops.
 *
 * Upload/delete live in useNativeCommunityVideos (the edit-form hook that feeds
 * the shared MediaUploadSection grid, parity with rituals).
 */

import { useQuery } from "@tanstack/react-query"
import { type CommunityVideoItem, listCommunityVideos } from "../services/communityVideo.service"

export function useCommunityVideos(
  communityId: string | undefined,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ["community-videos", communityId ?? ""],
    queryFn: () => listCommunityVideos(communityId as string),
    enabled: Boolean(communityId) && (options?.enabled ?? true),
    refetchInterval: query => {
      const data = query.state.data as CommunityVideoItem[] | undefined
      const stillProcessing = data?.some(v => v.status === "pending" || v.status === "processing")
      if (!stillProcessing) return false
      // Ceiling so an abandoned tab / server-stuck row doesn't poll forever.
      // dataUpdateCount increments on each successful fetch (~60 * 4s = 4 min).
      return query.state.dataUpdateCount >= 60 ? false : 4000
    },
  })
}
